import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../style/mycollection.css";
import { Link } from "react-router-dom";
import { getmycollection } from "../service/mycollection.service";

function MyCollections() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchCollections = async () => {
    try {
      setLoading(true);
      const data = await getmycollection();
      console.log("Collection Data:", data);
      setCollections(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // IMPORTANT
  useEffect(() => {
    fetchCollections();
  }, []);

  if (!loading && MyCollections?.length) return null;

  return (
    <section className="Collection-pages mt-1 mb-2 wow animate__animated animate__fadeInDown">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="text-lg text-gray-500 mb-2">
              MY COLLECTION
            </h2>
            <div className="border-bootemline"></div>
          </div>
        </div>
      </div>

      <div className="container my-4">
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : (
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 3,
              },
            }}
          >
            {collections.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="fade-image-box">
                  <Link to={item.buttonUrl || "#"}>
                    <img
                      src={item.media?.[0]?.image}
                      alt={item.media?.[0]?.altText || item.title}
                      className="fade-image img1"
                      loading="lazy"
                    />

                    <img
                      src={item.media?.[0]?.image}
                      alt={item.media?.[0]?.altText || item.title}
                      className="fade-image img2"
                    />
                  </Link>
                </div>

                <div className="box-div">
                  <div className="circle">
                    <i className="bi bi-arrow-up-right-circle"></i>
                  </div>
                  <h4 style={{ padding: "5px", fontWeight: "bold" }}>
                    {item.title}
                  </h4>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
}

export default MyCollections;